import headNav from '@src/components/head_nav'
import util from "@src/utils/util.js"
import { JsBridge, ActStat } from '@ie-activity/oversea-act-js-lib'


let vm = {
  components: {
    headNav,
  },
  data() {
    return {
      showTip: true,
      isNight: false,
      rule: "",
      isShowCutLine: false
    };
  },
  async mounted() {
    this.isNight = util.isNight()
    this.rule = this.$route.params.rule
    this.setStatusBarFontColor(false)
    let that = this
    window.onscroll = () => {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 23) {
        that.isShowCutLine = true
      } else {
        that.isShowCutLine = false
      }
    }

  },
  methods: {
    setStatusBarFontColor(isWhiteFont) {
      if (JsBridge.getEnv() === 'gameHall') {
        console.log(12312)
        window.android.setStatusBarFontColor(isWhiteFont)
      }
    },
  }
};

export default vm;



// WEBPACK FOOTER //
// ./src/pages/rulePage/scripts/index.js